import { useTranslation } from "react-i18next";

const packageJsonInfo = require("../../../../package.json");

export function VersionIndicator() {
  const { t } = useTranslation();
  return (
    <div className="sideBar_footer_version">
      <span className="sidebar-version">{t("navigation.version", { version: packageJsonInfo.version })}</span>
    </div>
  );
}
